<template>
    <b-container>
      <b-row>
        <h1>Semanteer - a comprehensive search platform</h1>
      </b-row>
      <b-row>
      <b-card title="Search UI" v-if="show_ui"
          style="max-width: 20rem;"
          class="mb-2 search-widget">

          <p class="card-text">
          From installation to searching in minutes: instant prototyping and testing through our out-of-the-box UI.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="ui==true" variant="success">Running</b-badge>
            <b-badge v-if="ui==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/ui/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>
      <b-card title="Semanteer VUI" v-if="show_vui"
          style="max-width: 20rem;"
          class="mb-2 search-widget">

          <p class="card-text">
          From installation to searching in minutes: instant prototyping and testing through our vuejs-based UI.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="vui==true" variant="success">Running</b-badge>
            <b-badge v-if="vui==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/vui/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>

      <b-card title="Admin Panel" v-if="show_config"
          style="max-width: 20rem;"
          class="mb-2 search-widget">
          <p class="card-text">
            Deep configurability and intelligent search features through Semanteer's admin panel.
          </p>
          <p>
            <span v-if="semanteer"><b>Version:</b> {{semanteer.build.version}}</span>
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="sl==true" variant="success">Running</b-badge>
            <b-badge v-if="sl==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/admin/index.html" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>

      <b-card title="Connectors" v-if="show_mcf"
          style="max-width: 20rem;"
          class="mb-2 search-widget">
          <p class="card-text">
          Index everything from everywhere - all data connectors under full control.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="mcf==true" variant="success">Running</b-badge>
            <b-badge v-if="mcf==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/mcf-crawler-ui/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>

      <b-card title="Solr" v-if="show_solr"
          style="max-width: 20rem;"
          class="mb-2 search-widget">

          <p class="card-text">
          Start from one of our standardized schemas and tailor it to fit exactly your needs.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="solr==true" variant="success">Running</b-badge>
            <b-badge v-if="solr==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/solr/#/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>

      <b-card title="Monitoring" v-if="show_monitoring"
          style="max-width: 20rem;"
          class="mb-2 search-widget">
          <p class="card-text">
          In-depth analysis and insights of users' search behaviour.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="monitoring==true" variant="success">Running</b-badge>
            <b-badge v-if="monitoring==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/monitoring/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>

      <b-card title="Console" v-if="show_console"
          style="max-width: 20rem;"
          class="mb-2 search-widget">
          <p class="card-text">
          Status and console for installed applications.
          </p>

          <div slot="footer">
          <p>
            <!--
            <b-badge v-if="console==true" variant="success">Running</b-badge>
            <b-badge v-if="console==false" variant="danger">Down</b-badge>
            -->
            <b-button href="/console/" target="_blank" variant="primary" class="float-right">Open</b-button>
          </p>
          </div>
      </b-card>
      </b-row>
    </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  created: function () {
    this.$store.commit('updateState')
  },
  computed: {
    semanteer () {
      return this.$store.state.semanteer
    },
    solr () {
      return this.$store.state.solr
    },
    mcf () {
      return this.$store.state.mcf
    },
    ui () {
      return this.$store.state.ui
    },
    vui () {
      return this.$store.state.ui
    },
    monitoring () {
      return this.$store.state.monitoring
    },
    console () {
      return this.$store.state.console
    },
    sl () {
      return this.$store.state.sl
    },
    show_ui() {
      return process.env.VUE_APP_SHOW_UI=="true";
    },
    show_vui() {
      return process.env.VUE_APP_SHOW_VUI=="true";
    },
    show_mcf() {
      return process.env.VUE_APP_SHOW_MCF=="true";
    },
    show_solr() {
      return process.env.VUE_APP_SHOW_SOLR=="true";
    },
    show_config() {
      return process.env.VUE_APP_SHOW_CONFIG=="true";
    },
    show_monitoring() {
      return process.env.VUE_APP_SHOW_MONITORING=="true";
    },
    show_console() {
      return process.env.VUE_APP_SHOW_CONSOLE=="true";
    }
  }
}
</script>

<style>
  .search-widget {
    margin-right: 20px;
    margin-top: 10px;
  }
</style>
